import { render, staticRenderFns } from "./ApplicationSideBar.vue?vue&type=template&id=961be09a&scoped=true&"
import script from "./ApplicationSideBar.vue?vue&type=script&lang=ts&"
export * from "./ApplicationSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationSideBar.vue?vue&type=style&index=0&id=961be09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961be09a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VNavigationDrawer,VTooltip})
